import { ObjectTypes } from '../../shared/enums/objectTypes';

export class ExportPdfViewModel {
  accountId: number;
  employeeId: number;
  title: string;
  objectType: ObjectTypes;
  objectId: number;
  includeImages: boolean;
}

export class ReportExportRequestViewModel {
  reportItemId: number;
  reportItemSectionId: number;
  title: string;
  description: string;
  showFilters: boolean;
  objectType: number;
}
